import FullCalendar from "@fullcalendar/react";
import React from "react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import styled from "styled-components";
import { useAuth } from "alpha-ui";

const CalndarWrapper = styled.div`
  height: 100%; /* ✅ Full Height of Parent */

  .fc {
    color: #fff;
    height: 100% !important; /* ✅ Full Height */
  }

  .fc-view-harness-active {
    height: 100% !important; /* ✅ Full Height */
  }
  .fc td,
  .fc th {
    vertical-align: center;
  }

  .fc-header-toolbar {
    background-color: #081336;
    color: white;
  }

  .fc-event-main-frame {
    color: #fff;
    background-color: green;
    padding: 10px 4px;
    cursor: pointer;
  }
  .fc .fc-daygrid-day-frame {
    min-height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  .fc .fc-daygrid-day {
    cursor: pointer; /* ✅ Pointer Cursor */
  }

  .fc .fc-daygrid-day:hover {
    background-color: #f3ad6c !important; /* ✅ Full Date Box Hover Effect */
  }
  .fc-button {
    border: 1px solid #fff !important;
    background: #fff;
    color: #f3ad6c;
    font-size: 14px;
    text-transform: uppercase;

    &.disabled {
      background:rgb(129, 105, 82);
      color: #fff;
    }
  }
  .fc-button:hover,
  .fc-button:focus {
    background-color: #f3ad6c !important;
    box-shadow: none;
    color:#fff;
    outline: none !important;
  }
  @media (max-width: 768px) {
    .fc-button {
      padding: 2px;
      font-size: 12px;
    }
    .fc {
      height: auto;
    }

    .fc-view-harness-active {
      height: auto !important; /* ✅ Full Height */
    }
    .dqASnc .fc-header-toolbar {
      flex-direction: row;
      text-align: start;
    }
  }
  .fc .fc-daygrid-day-events,
  .fc-daygrid-day-bg {
    display: none;
  }

  .fc-daygrid-day-number {
    padding: 0px;
    position: unset;
  }

  .fc-daygrid-day-top {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background-color: transparent;
  }

  .fc-daygrid-day.fc-day-disabled {
    background-color: rgb(82, 81, 81);
    pointer-events: none;
    color: #fff;
    opacity: 0.5;
    border: 1px solid #777;
  }

  @media (max-width: 991px) {
    .fc-daygrid-day-top {
      height: auto;
    }

    .fc-col-header-cell-cushion {
      font-size: 14px;
      font-weight: 400;
    }

    .fc .fc-daygrid-day-top {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 4px;
    }

    .fc .fc-toolbar-title {
      font-size: 1em;
      margin: 0px;
    }
  }

  @media (max-width: 340px) {
    .fc-daygrid-day-number {
      font-size: 12px;
    }

    .fc .fc-toolbar-title {
      font-size: 0.9em;
    }
  }

  .fc-daygrid-day-events {
    min-height: 0;
  }

  // .fc-button-primary {

  // }
`;

const CustomCalendar = ({ calenderData, handleDateClick }) => {
  const { auth } = useAuth();
  const headerOptions = {
    left: "prev,next today",
    center: "title",
    right: "",
  };

  const handleClickWithProps = (info) => {
    handleDateClick(info);
  };

  const calendarOptions = {
    headerToolbar: headerOptions,
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: "dayGridMonth",

    validRange: {
      start: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), // ✅ Go back up to 1 year
      end: new Date(), // ✅ Disable future months
    },

    dayCellClassNames: function (arg) {
      const today = new Date();
      const date = new Date(arg.date);

      if (auth?.user?.role === "10") return [];

      if (date > today) {
        return ["fc-day-disabled"];
      }

      if (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      ) {
        return ["fc-day-today"];
      }

      return [];
    },

    dayCellContent: function (arg) {
      return (
        <div
          className="element_date"
          onClick={() => handleClickWithProps(arg.date)}
        >
          {arg.dayNumberText}
        </div>
      );
    },
  };

  return (
    <CalndarWrapper>
      <FullCalendar headerToolbar={headerOptions} {...calendarOptions} />
    </CalndarWrapper>
  );
};

export default CustomCalendar;
